import React, { useEffect, useRef, useState } from 'react';
import { STATS } from '../data/content';
import './Stats.css';

function CountUp({ target }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  const isStatic = target.includes('/');

  useEffect(() => {
    if (isStatic) return;
    const num = parseInt(target.replace(/\D/g, '')) || 0;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started.current) {
        started.current = true;
        let start = 0;
        const step = Math.ceil(num / 60);
        const timer = setInterval(() => {
          start += step;
          if (start >= num) { setCount(num); clearInterval(timer); }
          else setCount(start);
        }, 25);
      }
    }, { threshold: 0.5 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target, isStatic]);

  if (isStatic) return <span ref={ref}>{target}</span>;

  const prefix = target.match(/^[^\d]*/)?.[0] || '';
  const suf = target.includes('+') ? '+' : target.includes('%') ? '%' : '';

  return <span ref={ref}>{prefix}{count}{suf}</span>;
}

export default function Stats() {
  return (
    <section className="stats-section">
      <div className="stats-grid-lines" />
      <div className="stats-inner">
        {STATS.map((s, i) => (
          <div key={s.label} className="stat-card" style={{ animationDelay: `${i * 0.1}s` }}>
            <div className="stat-value">
              <CountUp target={s.value} />
            </div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
